<template>
  <div>
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">
          QR Upload
        </span>
      </div>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <div class="box">
            <div>
              <div class="row col-12">
                <!-- Title -->
                <div class="col-6">
                  <v-text-field
                  v-model="formData.title"
                  outlined
                  dense
                  label="Title *"
                  hide-details="auto"
                  class="mb-6"
                  :rules="[validators.required]"
                  :error-messages="errors.title"
                  @change="errors.title = []"
                ></v-text-field>
                </div>
                <div class="col-6">
                <!-- ✅ Phone Numbers Text Area -->
                   <v-textarea
                  v-model="formData.phone_numbers"
                  outlined
                  dense
                  label="Phone numbers (comma separated)"
                  rows="3"
                  auto-grow
                  class="mb-6"
                  hide-details="auto"
                  :error-messages="errors.phone_numbers"
                  @change="errors.phone_numbers = []"
                ></v-textarea>
                </div>
              </div>
              <div class="row col-12">
                <div class="col-6">
              <!-- ✅ Excel Upload -->
                <v-file-input
                  v-model="formData.excel_file"
                  accept=".xlsx,.xls"
                  label="Upload Excel File"
                  outlined
                  dense
                  prepend-icon=""
                  class="mb-6"
                  hide-details="auto"
                  clearable
                  :error-messages="errors.excel_file"
                  @change="errors.excel_file = []"
                ></v-file-input>
                &nbsp;
                <!-- Live from Date -->
                </div>
                <div class="col-6">
                <v-menu
                  v-model="liveFromDatePickerShow"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formData.live_from"
                      label="Live from date *"
                      readonly
                      v-bind="attrs"
                      outlined
                      dense
                      :error-messages="errors.live_from"
                      :rules="[validators.required]"
                      v-on="on"
                      @change="errors.live_from = []"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.live_from"
                    :max="formData.live_upto"
                    @input="liveFromDatePickerShow = false"
                  ></v-date-picker>
                </v-menu>
                &nbsp;
              </div>
              </div>
              </div>
              <div class="row col-12">
                <div class="col-6">

                <!-- Live upto Date -->
                <v-menu
                  v-model="liveUptoDatePickerShow"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formData.live_upto"
                      label="Live upto date *"
                      readonly
                      v-bind="attrs"
                      outlined
                      dense
                      :error-messages="errors.live_upto"
                      :rules="[validators.required]"
                      v-on="on"
                      @change="errors.live_upto = []"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.live_upto"
                    :min="formData.live_from"
                    @input="liveUptoDatePickerShow = false"
                  ></v-date-picker>
                </v-menu>
                &nbsp;
                </div>
                <div class="col-6">

                <!-- Image Upload -->
                <v-file-input
                  v-if="formData.image === null"
                  v-model="formData.image_file"
                  :aspect-ratio="16/9"
                  accept="image/*"
                  label="Image file"
                  outlined
                  dense
                  prepend-icon=""
                  class="mb-6"
                  hide-details="auto"
                  clearable
                  :rules="[validators.required]"
                  :error-messages="errors.image_file"
                  @change="loadImage"
                ></v-file-input>
              </div>
              </div>
            </div>

            <!-- Submit -->
            <v-btn
              color="primary"
              block
              type="submit"
            >
              {{ 'Submit' }}
            </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mdiClose } from '@mdi/js'
import { required } from '@core/utils/validation'
import _ from 'lodash'
import CONSTANTS from '@/constants'

const blankFormData = {
  title: '',
  phone_numbers: '',   // ✅ phone numbers field
  excel_file: null,    // ✅ excel upload field
  live_from: null,
  live_upto: null,
  image: null,
  image_file: null,
}

export default {
  name: 'UploadQR',
  data() {
    return {
      url: null,
      tab: 0,
      formData: _.cloneDeep(blankFormData),
      form: null,
      valid: true,
      errors: {},
      validators: { required },
      icons: { mdiClose },
      liveFromDatePickerShow: false,
      liveUptoDatePickerShow: false,
    }
  },
  methods: {
    prepareFromData() {
      const formData = new FormData()
      Object.entries(this.formData).forEach(([key, value]) => {
        if (value !== null && value !== '') {
          formData.append(key, value)
        }
      })
      return formData
    },
    store() {
      const formData = this.prepareFromData()
      this.$store
        .dispatch('qrUpload/store', formData)
        .then(response => {
          this.isVisible = false
          this.$emit('onComplete')
          this.$store.commit('app/SET_SNACKBAR_SUCCESS', response.data?.message)
          this.$router.push('/qr_list')
        })
        .catch(error => {
          const { errors } = error.response.data
          if (errors) {
            this.$set(this, 'errors', errors)
            this.$set(this, 'valid', false)
          }
          this.$store.commit('app/SET_SNACKBAR_ERROR', error.response.data?.message)
        })
    },
    onSubmit() {
      if (this.valid) {
        this.store()
      } else {
        this.$refs.form.validate()
      }
    },
  },
}
</script>
